import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { ordersOperationalDashboardRouter } from './routing/ordersOperationalDashboardRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { ordersOperationalDashboardDashboardAccessControl } from './access-control/ordersOperationalDashboardDashboardAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'orders-operational-dashboard',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'orders-operational-dashboard-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [ordersOperationalDashboardRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsCustomerSupport,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'View and manage customer orders, track shipments, and handle adjustments',
          labelId: 'ordersOperationalDashboardDomain.nav.title',
          route: 'orders-operational-dashboard-dashboard-page',
          accessControl: ordersOperationalDashboardDashboardAccessControl,
          positionNavV2: 4,
          inToolPermissions: [
            {
              slug: Permission.OrdersOperationalConnectPlatformView,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalConnectPlatformView,
            },
            {
              slug: Permission.OrdersOperationalDashboardCancelOrder,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardCancelOrder,
            },
            {
              slug: Permission.OrdersOperationalDashboardAdjustOrder,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardAdjustOrder,
            },
            {
              slug: Permission.OrdersOperationalDashboardAdjustOrderBasketContext,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardAdjustOrderBasketContext,
            },
            {
              slug: Permission.OrdersOperationalDashboardCustomersView,
              permissionLabelId:
                'permissionAccordion.permissions.' +
                Permission.OrdersOperationalDashboardCustomersView,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
